import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import { Link } from "react-router-dom";
import ActionCell from "./components/ActionCell";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import { useTranslation } from "react-i18next";
import CashBoxApi from "api/cashBox";
import { CircularProgress } from "@mui/material";

function CaisseList() {
  const { t } = useTranslation();
  const [cashBoxes, setCashBoxes] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");

  const userData = JSON.parse(localStorage.getItem("user"));
  const role = userData?.business_role_id || null;
  const dashboard_access = role === "warehouse_owner" || role === "admin";

  useEffect(() => {
    const fetchCashBoxes = async () => {
      try {
        const response = await CashBoxApi.GetCashBoxesList(token);
        setCashBoxes(response.data.results);
      } catch (error) {
        console.error("Erreur lors du chargement des caisses :", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCashBoxes();
  }, [token]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        minHeight="85vh"
      >
        <SoftBox py={3}>
          {dashboard_access && cashBoxes.length === 0 && (
            <Link to="/gestion-financiere/nouvelle-caisse">
              <SoftButton variant="gradient" color="info">
                + {t("Nouvelle caisse")}
              </SoftButton>
            </Link>
          )}

          <Grid container spacing={3} mt={1}>
            {loading ? (
              <SoftBox
                display="flex"
                justifyContent="center"
                alignItems="center"
                p={35}
              >
                <CircularProgress sx={{ color: "#1F51FF" }} />
              </SoftBox>
            ) : (
              cashBoxes?.map((caisse) => (
                <Grid item xs={12} md={6} key={caisse.id}>
                  <Card sx={{ display: "flex", boxShadow: 3, pt: 1 }}>
                    <CardContent
                      sx={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <SoftBox sx={{ width: "90%" }}>
                        <SoftTypography variant="h5" gutterBottom>
                          {caisse.cash_box_name}
                        </SoftTypography>

                        <SoftTypography variant="body2" color="textSecondary">
                          {t("Montant actuel")}:{" "}
                          {parseFloat(caisse.amount).toFixed(3)} TND
                        </SoftTypography>

                        <SoftBox
                          display="flex"
                          alignItems={{ xxl: "center" }}
                          justifyContent="space-between"
                          flexDirection={{
                            xs: "column",
                            xxl: "row",
                          }}
                          mt={2}
                        >
                          <SoftBox display="flex" alignItems="center">
                            <WarehouseIcon
                              fontSize="small"
                              sx={{ mr: 1, color: "#28a745" }}
                            />
                            <SoftTypography
                              variant="body2"
                              color="textSecondary"
                            >
                              {t("Entrepôt")}:{" "}
                              {caisse.warehouse
                                ? `ID ${caisse.warehouse}`
                                : t("Non spécifié")}
                            </SoftTypography>
                          </SoftBox>
                        </SoftBox>
                      </SoftBox>
                      {dashboard_access && <ActionCell id={caisse.id} />}
                    </CardContent>
                  </Card>
                </Grid>
              ))
            )}
          </Grid>
        </SoftBox>
        <Footer />
      </SoftBox>
    </DashboardLayout>
  );
}

export default CaisseList;
